import { DataStore, Predicates, SortDirection } from 'aws-amplify';
import { Post } from './models';

export const DEFAULT_POST_PAGE_SIZE = 10;

export const fetchPostsPage = async ({ page = 0, limit = DEFAULT_POST_PAGE_SIZE } = {}) =>
  DataStore.query(Post, Predicates.ALL, {
    sort: sorter => sorter.createdAt(SortDirection.DESCENDING),
    page,
    limit,
  });

export const fetchRecentPosts = async (limit = 36) => fetchPostsPage({ page: 0, limit });

export const fetchPostById = async id => {
  const results = await DataStore.query(Post, record => record.id('eq', id));
  return results[0] || null;
};
